// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searched-workorders {
  width: 100%;
  /* padding: 10px; */
}
`, "",{"version":3,"sources":["webpack://./src/components/PrintPageSearchPanel/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".searched-workorders {\n  width: 100%;\n  /* padding: 10px; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
